<main class="page-shell map-page">
  <section *ngIf="loading" class="card state">Loading level map...</section>
  <section *ngIf="error" class="card state status-error">{{ error }}</section>

  <ng-container *ngIf="!loading && !error">
    <section class="card world" *ngFor="let world of worlds; trackBy: trackByWorld">
      <header>
        <h2>{{ world.worldName }}</h2>
        <span class="chip">{{ world.levels.length }} problems</span>
      </header>

      <div class="nodes">
        <button
          type="button"
          *ngFor="let level of world.levels; trackBy: trackByLevel"
          class="node"
          [class.locked]="level.status === 'LOCKED'"
          [class.completed]="level.status === 'COMPLETED'"
          [class.current]="level.status === 'UNLOCKED'"
          (click)="openLevel(level)"
        >
          <span class="number">{{ level.levelNumber }}</span>
          <div class="info">
            <strong>{{ level.title }}</strong>
            <small>{{ level.difficulty }} - +{{ level.xpReward }} XP</small>
          </div>
          <span class="state-text">
            {{ level.status === "COMPLETED" ? "Completed" : level.status === "UNLOCKED" ? "Available" : "Locked" }}
          </span>
        </button>
      </div>
    </section>
  </ng-container>
</main>

